import { createContext } from "react";
import { GoogleCalendarConnection, GoogleCalendarInfo } from "../types";

export interface GoogleCalendarContextType {
  connection: GoogleCalendarConnection | null;
  isConnected: boolean;
  isLoading: boolean;
  connectGoogleCalendar: () => Promise<void>;
  disconnectGoogleCalendar: () => Promise<void>;
  toggleSync: () => Promise<void>;
  fetchCalendarList: () => Promise<GoogleCalendarInfo[]>;
  toggleCalendarVisibility: (calendarId: string) => Promise<void>;
  setHiddenCalendarIds: (calendarIds: string[]) => Promise<void>;
}

export const GoogleCalendarContext = createContext<GoogleCalendarContextType | undefined>(undefined);
